import React from 'react';
import styled, { css } from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion6';
import PropTypes from 'prop-types';

export const Section = styled(motion.div)`
  ${({ $hideOverflow }) =>
    $hideOverflow &&
    css`
      overflow: hidden;
    `};
`;

const childrenVariants = {
  open: {
    opacity: 1,
    pointerEvents: 'auto'
  },
  closed: {
    opacity: 0,
    pointerEvents: 'none'
  }
};

const AnimatedAccordion = ({
  isOpen,
  children,
  marginTop,
  animatePresence,
  className,
  onAnimationComplete,
  hideOverflow = true
}) => {
  const sectionVariants = {
    open: {
      height: 'auto',
      ...(marginTop && { marginTop }),
      transition: {
        delayChildren: 0.15,
        stiffness: 80
      }
    },
    closed: {
      height: 0,
      ...(marginTop && { marginTop: 0 }),
      transition: { when: 'afterChildren' }
    }
  };

  if (animatePresence) {
    return (
      <AnimatePresence>
        {isOpen && (
          <Section
            variants={sectionVariants}
            animate="open"
            initial="closed"
            exit="closed"
            className={className}
            onAnimationComplete={onAnimationComplete}
          >
            <motion.div variants={childrenVariants}>{children}</motion.div>
          </Section>
        )}
      </AnimatePresence>
    );
  }

  return (
    <Section
      variants={sectionVariants}
      animate={isOpen ? 'open' : 'closed'}
      initial="closed"
      className={className}
      onAnimationComplete={onAnimationComplete}
      $hideOverflow={hideOverflow}
    >
      <motion.div variants={childrenVariants}>{children}</motion.div>
    </Section>
  );
};

AnimatedAccordion.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  marginTop: PropTypes.string,
  animatePresence: PropTypes.bool,
  className: PropTypes.string,
  onAnimationComplete: PropTypes.func,
  hideOverflow: PropTypes.bool
};

export default AnimatedAccordion;
